import React from "react";
import { graphql } from "gatsby";
import { SeoMetadata } from "@components/shared/seoMetadata";
import { generateLandingPageSchema } from "@utils/schemaGenerators";
import * as c from "./landingPages.module.scss";

import FeaturePage from "./featurePage";
import BusinessPage from "./businessPage";
import CompetitorPage from "./competitorPage";
import DirectMailPage from "./directMailPage";

const LandingPage = ({ data }) => {
  const { contentfulLandingPage } = data;

  switch (contentfulLandingPage.pageVariant[0]) {
    case "Feature Page":
      return <FeaturePage contentfulLandingPage={contentfulLandingPage} />;
    case "Business Page":
      return <BusinessPage contentfulLandingPage={contentfulLandingPage} />;
    case "Competitor Page":
      return <CompetitorPage contentfulLandingPage={contentfulLandingPage} />;
    case "Direct Mail Page":
      return <DirectMailPage contentfulLandingPage={contentfulLandingPage} />;
    default:
      return <FeaturePage contentfulLandingPage={contentfulLandingPage} />;
  }
};

export default LandingPage;

export const Head = ({ data }) => {
  return (
    <>
      <SeoMetadata
        {...data.contentfulLandingPage.seoMetadata}
        additionalSchemas={generateLandingPageSchema(data.contentfulLandingPage)}
      />
      <body className={c.clipHorizontalOverflow} />
    </>
  );
};

export const query = graphql`
  query LandingPageQuery($slug: String!) {
    contentfulLandingPage(slug: { eq: $slug }) {
      ...landingPageCoreFields
      ...landingPageHeaderFields
      ...landingPageSectionFields
      ...landingPageActionSectionFields
    }
  }
`;
